/* oxlint-disable typescript/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { clickSellerSendForm, successSellerSendForm } from 'shared/landingSeller/components/tracking';
import { ResponseError } from 'shared/common/errors/responseError';
import { fetchSaveForm } from 'shared/common/services/fetchSaveForm';
import { setModalStatus } from 'shared/common/slices';
import { EFormStatus, TSendFormParams } from 'shared/common/types/form';
import { EModalStatus } from 'shared/common/types/modal';
import { IThunkApi } from 'shared/common/types/redux';
import { clickBuyerSendForm, failedBuyerSendForm, successBuyerSendForm } from '../../../landingBuyer/utils/tracking';
import { EPageName } from '../../constants/pages';
import { EDealType } from '../../repositories/cpd/entities/v1_create_cpd_draft/PublicV1CreateCpdDraftRequest';

/* istanbul ignore next */
export const sendForm = createAsyncThunk<EFormStatus, TSendFormParams, IThunkApi>(
  'form/sendForm',
  async (formParams, _thunkApi) => {
    const { rejectWithValue, extra, dispatch } = _thunkApi;
    const isSellerLanding = extra.custom.pageName === EPageName.LandingSeller;

    const successSendForm = isSellerLanding ? successSellerSendForm : successBuyerSendForm;
    const clickSendForm = isSellerLanding ? clickSellerSendForm : clickBuyerSendForm;

    clickSendForm(extra.custom);

    try {
      const { response, statusCode } = await fetchSaveForm(extra, {
        source: formParams.source,
        address: formParams.polygon,
        dealType: isSellerLanding ? EDealType.Sale : EDealType.Buy,
        phone: formParams.phone,
        legalAgreementAccepted: formParams.legalAgreementAccepted,
        cianSource: extra.custom.source,
        utmMedium: extra.custom.utm_medium,
        utmSource: extra.custom.utm_source,
        utmCampaign: extra.custom.utm_campaign,
        referrer: extra.custom.referrer,
        referralCode: extra.custom.referralCode,
      });

      dispatch(setModalStatus(EModalStatus.Open));

      if (statusCode !== 200) {
        if (!isSellerLanding) {
          failedBuyerSendForm(extra.custom);
        }

        throw new ResponseError({
          domain: 'b2b-marketing-cpd-frontend',
          message: JSON.stringify(response.message),
        });
      }

      successSendForm(response.cpdDraftId, extra.custom);

      return EFormStatus.Success;
    } catch (e) {
      if (!isSellerLanding) {
        failedBuyerSendForm(extra.custom);
      }

      return rejectWithValue(e);
    }
  },
);
